var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39791 9.16658L10.8991 3.66537L16.4003 9.16658H16.3991V18.3333H5.39914V9.16658H5.39791ZM3.56581 10.9987L2.21206 12.3524L0.916626 11.057L9.60386 2.36977C10.3192 1.65441 11.479 1.65441 12.1944 2.36977L20.8816 11.057L19.5862 12.3524L18.2325 10.9987V18.3333C18.2325 19.3458 17.4117 20.1666 16.3991 20.1666H5.39914C4.38662 20.1666 3.56581 19.3458 3.56581 18.3333V10.9987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.15b0b9c6b336ce050a779c92fbce6b68.svg";
export { ForwardRef as ReactComponent };